export default __webpack_public_path__ + "static/media/RoomCardImg.948eb651.svg";